import React from 'react';

interface Props {
	size: number;
}

export const GeneralDegreeIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>generalDegree</title>
		<path d='M23.21 13.23h-9a.43.43 0 010-.86h9a.43.43 0 110 .86zM23.21 17.63h-9a.43.43 0 01-.43-.43.43.43 0 01.43-.43h9a.44.44 0 01.43.43.43.43 0 01-.43.43z' />
		<path d='M22.38 17.6H4.49a1.72 1.72 0 01-1.72-1.72v-1.76a1.72 1.72 0 011.72-1.72h17.89zM4.49 13.26a.86.86 0 00-.86.86v1.76a.85.85 0 00.86.86h17v-3.48zM20.8 7.23h-9a.44.44 0 01-.43-.43.43.43 0 01.43-.43h9a.43.43 0 01.43.43.43.43 0 01-.43.43zM20.8 11.63h-9a.43.43 0 110-.86h9a.43.43 0 010 .86z' />
		<path d='M20 11.6H2.08A1.73 1.73 0 01.36 9.88V8.12A1.73 1.73 0 012.08 6.4H20zM2.08 7.26a.86.86 0 00-.86.86v1.76a.87.87 0 00.86.86h17V7.26z' />
		<path d='M10.17 9h-7.4a.43.43 0 01-.43-.43.43.43 0 01.43-.43h7.4a.43.43 0 01.43.43.43.43 0 01-.43.43zM20.18 15.83h-4.6a.43.43 0 01-.43-.43.43.43 0 01.43-.43h4.6a.43.43 0 01.43.43.43.43 0 01-.43.43z' />
	</svg>
);
